<template>
    <b-form-group :label="label" :description="description" :invalid-feedback="validationError">
        <b-form-input v-model="content" @input="updateContent()" :type="type" :state="state"></b-form-input>
    </b-form-group> 
</template>

<script>
export default {
  name: "TextControl",
  props: {
    label: {},
    description: {},
    type: {
      default: 'text'
    },
    value: {
      required: true
    },
    required: {
      default: false
    },
    requiredError: {
      default: 'This field is required'
    },
    minLength: {
      default: null
    },
    minLengthError: {
      default: function () {
        return 'This field must be at least ' + this.minLength + ' characters long';
      }      
    },
    maxLength: {
      default: null
    },
    maxLengthError: {
      default: function () {
        return 'This field must not be more than ' + this.minLength + ' characters long';
      }
    },
    minValue: {
      default: null
    },
    minValueError: {
      default: function () {
        return 'The value cannot be less than ' + this.minValue + '.';
      }
    },
    maxValue: {
      default: null
    },
    maxValueError: {
      default: function () {
        return 'The value cannot be greater than ' + this.maxValue + '.';
      }
    },
    customValidation: {}
  },
  data() {
    return {
      content: this.value,
      originalValue: this.value,
      state: null,
      validationError: null,
      hasEverValidated: false
    };
  },
  computed: {
    isValid: function () {
      if (!this.hasEverValidated)
        this.validateContent(this.content, this.content);

      return this.state === null || this.state === true;
    }
  },
  methods: {
    updateContent() {
      this.$emit('input', this.content);
    },
    validateContent(newValue, oldValue) {
      this.hasEverValidated = true;

      let validationError = null;

      if (this.required !== null && this.required !== false && newValue == '')
        validationError = this.requiredError;
      else if (this.minLength && this.minLength > 0 && newValue.length < this.minLength)
        validationError = this.minLengthError;
      else if (this.maxLength && this.maxLength > 0 && newValue.length > this.maxLength)
        validationError = this.maxLengthError;
      else if (this.minValue && newValue < this.minValue)
        validationError = this.minValueError;
      else if (this.maxValue && newValue > this.maxValue)
        validationError = this.maxValueError;
      else if (typeof(this.customValidation) === 'function') {
        let retVal = this.customValidation(newValue, oldValue, this.validateContent);
        if (retVal !== true && retVal !== null)
          validationError = retVal;
        else {
          this.state = retVal;
          validationError = null;
        }
      }

      this.validationError = validationError;
      if (this.validationError != null)
        this.state = false;
      else {
        if (this.originalValue == newValue)
          this.state = null;
        else
          this.state = true;
      }
    }
  },
  watch: {
    content: function (newValue, oldValue) {
      this.validateContent(newValue, oldValue);
    },
    value: function (newValue, oldValue) {
      this.content = newValue;
    }
  },
  mounted () {
  }
};
</script>